var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"fixed flex items-center justify-center",class:{
      'hidden': _vm.scY <= 300,
      'pagetop-pwa': _vm.isPWA,
    },attrs:{"id":"pagetop"},on:{"click":_vm.toTop}},[_c('SfImage',{staticClass:"rotate-270",attrs:{"src":_vm.addBasePath('/icons/arrow-small-right.svg'),"alt":"right arrow","height":14,"width":14}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }